import { render, staticRenderFns } from "./PropostaPrecoForm.vue?vue&type=template&id=71ae46cf&"
import script from "./PropostaPrecoForm.vue?vue&type=script&lang=js&"
export * from "./PropostaPrecoForm.vue?vue&type=script&lang=js&"
import style0 from "./PropostaPrecoForm.vue?vue&type=style&index=0&id=71ae46cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports